import { render, staticRenderFns } from "./RemoteMonitoringIndicatorsView.vue?vue&type=template&id=bb8ea476"
import script from "./RemoteMonitoringIndicatorsView.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringIndicatorsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports